<template>
  <card class="card" title="Upload TIDs & Terminals">
    <form @submit.prevent>
      <div class="row">
        <div class="col-md-4">
          <label>Institution Name</label>

          <select
            class="form-control op-border"
            id="rate-type"
            v-model="institutionId"
            required
          >
            <option value="">Select Institution</option>
            <option
              v-for="institution in allInstitutions"
              :key="institution._id"
              :value="institution.institutionName"
            >
              {{ institution.institutionName }}
            </option>
          </select>
        </div>
      </div>

      <h4>Upload Bulk TIDs</h4>
      <div class="col-md-6">
        <label
          >Upload CSV File<span class="required" v-if="!bulkFile"
            >*</span
          ></label
        >
        <input
          type="file"
          class="form-control"
          accept=".csv"
          @change="bulkFileChange"
          ref="bulkFileInput"
        />
      </div>

      <div class="text-center">
        <p-button
          type="info"
          round
          @click.native.prevent="submitBulk"
          :disabled="!bulkFile || loading.show"
        >
          <div
            class="spinner-grow"
            role="status"
            v-if="loading.show === true"
          ></div>
          Submit Bulk Upload
        </p-button>
      </div>
    </form>
  </card>
</template>

<script>
import axios from "../store/axios";
import { mapState, mapActions } from "vuex";
import Multiselect from "vue-multiselect";
export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      file: "",
      bulkFile: "",
      institutionId: "",
      allInstitutions: [],
    };
  },
  computed: {
    ...mapState(["auth", "loading", "utils"]),
  },
  methods: {
    ...mapActions(["uploadTerminal", "getMerchants", "setNotification"]),

    async submitBulk() {
      const formData = new FormData();
      console.log(this.institutionId);
      if (this.institutionId !== "") {
        console.log(this.institutionId);
        formData.append("bankName", this.institutionId);
      }
      formData.append("csvFile", this.bulkFile);

      this.loadingLocal = true;
      try {
        const res = await axios.post(
          `${process.env.VUE_APP_API_URL}/tid/upload`,
          formData,
        );
        this.setNotification({
          message: res.data.message,
          type: "success",
        });
        // this.bulkFile = "";
        // if (this.$refs.bulkFileInput) {
        //   this.$refs.bulkFileInput.value = "";
        // }
      } catch (error) {
        console.error(error);
        this.setNotification({
          message: "Error uploading file, try again",
          type: "danger",
        });
      } finally {
        this.loadingLocal = false;
        this.bulkFile = "";
      }
    },

    submit() {
      const formData = new FormData();
      //   formData.append("csvFile", this.file);
      console.log(this.institutionId);
      if (this.institutionId !== "") {
        formData.append("institutionId", this.institutionId);
      }
      this.uploadTerminal(formData);
    },

    fileChange(e) {
      const file = e.target.files[0];
      this.file = file;
    },
    bulkFileChange(e) {
      this.bulkFile = e.target.files[0] || "";
    },

    async getAllInstitutions() {
      try {
        const res = await axios.post(
          `${process.env.VUE_APP_API_URL}/get-institution-list`,
        );

        const institutions = res.data.institutions;
        this.allInstitutions = institutions;
      } catch (err) {
        const { data } = err.response.data;
        if (data) {
          this.setNotification({
            type: "danger",
            message: data.message || "Unable to Fetch All Institutions",
          });
        }
      }
    },
  },

  async mounted() {
    await this.getAllInstitutions();
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.required {
  color: red;
  margin-left: 2px;
}

.required-field {
  font-size: 0.8rem;
  color: #888;
  margin-left: 5px;
}
</style>
